
import api from "../../../../api/axios";

/**
 * Get Title & Escrow cost calculation from backend.
 * @param {Object} payload - Required body data for calculation
 * @param {Object} params - Optional params { mainid, userid, companyid }
 * @returns {Promise<Object>} API response data
 */

export const getTitleEscrowCosts = async (payload, params = {}) => {
  try {
    const res = await api.post(`/refinance-title-escrow-costs`, payload);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getStateSettings = async (params = {}) => {
  try {
    const res1 = await api.get(`/state-setting`, { params });


   // const res2 = await api.post(`/closing-county`, { stateid: 5, countyid: 204, state: "California", county: "Los Angeles", zipcode: "" });
    return res1.data;
   // return res2.data;
  } catch (error) {
    throw error;
  }
};

export const getCountySettings = async (params = {}) => {
  try {
    const res = await api.get(`/county-setting`, { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getNationalSettings = async (params = {}, axiosConfig = {}) => {
  try {
    const res = await api.get(`/national`, { params, ...axiosConfig });
    return res.data;
  } catch (error) {
    throw error;
  }
};

